import React from 'react'
import { useQuery } from '@apollo/client';
import { BLOG_POSTS } from '../../../utils/constants/queries';
import { BlogSkeleton, ErrorComponent } from '../../../components/';
import { BlogPost } from '../../../components/';

export default function BlogPosts() {
    const { loading, error, data } = useQuery(BLOG_POSTS);
    if (loading) return <BlogSkeleton/>;
    if (error) return <ErrorComponent message={error.message}/>;

    return (
        <>
            {data.blog.map((post)=><>
                <BlogPost post = {post}/>
            </>
            )}

            <div className="col-lg-12 col-md-12">
                <div className="pagination-area">
                    <a href="_" className="prev page-numbers">
                        <i className="flaticon-left"></i>
                    </a>
                    <a href="_" className="page-numbers">1</a>
                    <span className="page-numbers current" aria-current="page">2</span>
                    <a href="_" className="page-numbers">3</a>
                    <a href="_" className="page-numbers">4</a>
                    <a href="_" className="next page-numbers">
                        <i className="flaticon-right"></i>
                    </a>
                </div>
            </div>

        </>
    )
}
